import React from 'react';
import { useField } from 'formik';
import { Input, Upload, message } from 'antd';


export const FormikInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <div style={{ marginBottom: '16px' }}>
      {label && <label>{label}</label>}
      <Input {...field} {...props} />
      {meta.touched && meta.error ? (
        <div style={{textAlign:"left", color:"red"}} className="error">{meta.error}</div>
      ) : null}
    </div>
  );
};

export const FormikPassword = ({ label, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <div style={{ marginBottom: '16px' }}>
      {label && <label>{label}</label>}
      <Input.Password {...field} {...props} />
      {meta.touched && meta.error ? (
        <div style={{textAlign:"left", color:"red"}}  className="error">{meta.error}</div>
      ) : null}
    </div>
  );
};


